import { LoadingSpinner } from '@cfs-fixings/shared'
import { DesignResource, ProjectWithOrderedDesignsResource } from '@/api/serverApi'
import GroupedDesignListView from './views/GroupedDesignListView'
import GroupedDesignGridView from './views/GroupedDesignGridView'

type PropTypes = {
  projects?: ProjectWithOrderedDesignsResource[]
  footerElements?: React.ReactNode[]
  viewType?: 'list' | 'grid'
  isLoading?: boolean
  dropdown?: (design: DesignResource) => React.ReactNode
}

function BrowseGroupedDesignsView ({ projects, footerElements, viewType = 'list', isLoading = false, dropdown }: PropTypes) {
  return (
    <div className="w-full">
      {
        viewType === 'list'
          ? (
            <GroupedDesignListView
              projects={projects}
              footerElements={footerElements}
              dropdown={dropdown}
            />
          )
          : (
            <div className="px-1">
              <GroupedDesignGridView
                projects={projects}
                footerElements={footerElements}
                dropdown={dropdown}
              />
            </div>
          )
      }
      {
        isLoading
          ? <div className="w-full flex items-center justify-center pt-2">
            <LoadingSpinner className="h-4 w-4" />
          </div>
          : null
      }
    </div>
  )
}

export default BrowseGroupedDesignsView
